import {
  AutoComplete,
  Button,
  Checkbox,
  Form,
  Input,
  Modal,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { dispatchtoast, filterOption } from "../../../Utils";
import CommonInput from "../../../Common/CommonInput";
import {
  BalanceTransfer,
  DofavouriteDelete,
  getmemberForWalletTransfer,
  MemberList,
  MyFavouritesReport,
} from "../../../ApiServices/Apifun";
import CommonPagination from "../../../Common/Pagination";
import { setselectedTab } from "../../../Store/B2bslice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "antd/es/form/Form";
import { DeleteOutlined } from "@ant-design/icons";

const SendMoneyModal = () => {
  const [btnLoading, setBtnLoading] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchKeyword, setSearchKeyWord] = useState("");
  const [searchMember, setSearchMember] = useState("");
  const [searchcolumn, setSearchColumn] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [pageSize, setPageSize] = useState(10);
  const [current, setCurrent] = useState(1);
  const [dataSource, setDataSource] = useState([]);
  const profiledetail = useSelector((state) => state.B2B.profileDetail);
  const dispatch = useDispatch();
  const [memberTypeFilter, setMemberTypeFilter] = useState(null);
  const [memberOptions, setMemberOptions] = useState([]);
  const [isFavorite, setisFavourite] = useState(false);
  const [result, setResult] = useState({});
  const [form] = Form.useForm();
  const [selecteddata, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(setselectedTab("44"));
    // if (profiledetail.member_type === "Retailer") {
    //   navigate("/dashboard");
    // } else {
    // }
  }, []);

  const handleSend = (val) => {
    console.log(val);
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("member_id", val.member_id?.value);
    formdata.append("amount", val.amount);
    formdata.append("remark", val.remark);
    formdata.append("is_favorite", isFavorite ? 1 : 0);
    formdata.append("pin", val.pin);
    BalanceTransfer(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message);
          navigate("/give-topup");
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const ReportColumn = [
    {
      title: "Member Id",
      dataIndex: "member_id",
      key: "member_id",
      render: (text) => <p className=" font-medium  ">{text ?? "-"}</p>,
    },
    {
      title: "Member Name",
      dataIndex: "member_name",
      key: "member_name",
      render: (text) => {
        return (
          <>
            <p className=" font-medium  ">{text ?? "-"}</p>
          </>
        );
      },
    },
    {
      title: "Mobile",
      dataIndex: "member_mobile",
      key: "member_mobile",
      render: (text) => <p className=" font-medium">{text}</p>,
    },
    {
      title: "Business Name",
      dataIndex: "business_name",
      key: "business_name",
      render: (text) => (
        <p className="font-medium w-[100px]  px-3 overflow-y-scroll">{text}</p>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        return (
          <div className="flex gap-4 justify-center">
            <DeleteOutlined
              className=" text-white bg-primary rounded-md text-center p-2 text-base font-bold"
              onClick={() => {
                handleConfirm(record);
              }}
            />
          </div>
        );
      },
    },
  ];
  const handleConfirm = (record) => {
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("favorite_member_id", record.id);
    DofavouriteDelete(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.message, false);
          getFavourites();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  const getFavourites = () => {
    setLoading(true);
    const payload = {
      per_page: pageSize,
      page_no: current,
      search_keyword: searchKeyword,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    MyFavouritesReport(formdata)
      .then((res) => {
        setDataSource(res.data);
        setTotalPages(res.total);
        // setSearchOptions(
        //   res?.filter_column_name?.map((i, index) => {
        //     return {
        //       label: i,
        //       value: res.filter_column_key[index],
        //     };
        //   })
        // );
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };
  useEffect(() => {
    getFavourites();
  }, [current, pageSize, searchKeyword]);

  const getMemberWalletTransfer = () => {
    const payload = {
      search_keyword: searchMember,
    };
    const formdata = new FormData();
    Object.keys(payload).map((key) => formdata.append(key, payload[key]));
    getmemberForWalletTransfer(formdata)
      .then((res) =>
        setMemberOptions(
          res.data.map((i, index) => {
            return {
              label: i.display_text,
              value: i.id,
              key: i.id,
            };
          }),
        ),
      )
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    getMemberWalletTransfer();
  }, [searchMember]);
  useEffect(() => {
    if (result?.Id && memberOptions.length > 0) {
      form.setFieldsValue({
        member_id: {
          value: result.Id,
          label: result.MemberName,
        },
      });
    }
  }, [result, memberOptions]);

  return (
    <>
      <div className="mt-3">
        <div className="prepaid  animate-fade-in w-full  bg-white shadow-normal  rounded-xl p-4">
          <div className="flex justify-between items-center">
            <p className="font-bold text-[15px] mb-2">
              Balance Transfer Report
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 bg-white p-4 mt-4">
          <Form
            form={form}
            className=" shadow-md shadow-gray-300 p-4"
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleSend(val)}
          >
            <div className="grid grid-cols-1 gap-x-3 place-items-center">
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Select a member",
                  },
                ]}
                name={"member_id"}
                label="Member"
                labelCol={{ span: 24 }}
                className="w-full"
              >
                <Select
                  labelInValue
                  showSearch
                  placeholder="Enter mobile number"
                  className="w-full mt-2"
                  filterOption={false}
                  options={searchMember ? memberOptions : []}
                  onSearch={(value) => {
                    setSearchMember(value);
                    if (!value) {
                      setMemberOptions([]);
                    }
                  }}
                />
              </Form.Item>

              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Enter amount",
                  },
                ]}
                label="Amount"
                name={"amount"}
                labelCol={{ span: 24 }}
                className="w-full"
              >
                <CommonInput
                  onInput={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    e.target.value = value;
                  }}
                  placeholder="Amount"
                  className="outline-none text-xs border w-full  border-gray-200 focus:border-primary  h-8 px-2"
                />
              </Form.Item>
            </div>
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "Enter pin",
                },
              ]}
              label="Pin"
              name={"pin"}
              labelCol={{ span: 24 }}
              className="w-full mt-2"
            >
              <CommonInput
                maxlength={4}
                onInput={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  e.target.value = value;
                }}
                placeholder="Pin"
                className="outline-none text-xs border w-full  border-gray-200 focus:border-primary  h-8 px-2"
              />
            </Form.Item>
            <Form.Item
              label="Remark"
              name={"remark"}
              labelCol={{ span: 24 }}
              className="w-full mt-2"
            >
              <CommonInput
                placeholder="Remark"
                className="outline-none text-xs border w-full  border-gray-200 focus:border-primary  h-8 px-2"
              />
            </Form.Item>
            <Form.Item labelCol={{ span: 24 }} className="w-5 mt-2">
              <div className="mt-2 flex justify-start items-center gap-x-3  checkbox">
                <Input
                  checked={isFavorite}
                  onChange={(e) => setisFavourite(!isFavorite)}
                  className="rounded-sm"
                  type="checkbox"
                />
                <p className="text-textGray">Add To Favourite</p>
              </div>
            </Form.Item>

            <div className="flex justify-end mt-4 items-center gap-x-4">
              <Form.Item>
                <Button
                  className="bg-primary text-white hover:border-none border-none"
                  loading={btnLoading}
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </Form>
          <div className=" shadow-md shadow-gray-300">
            <p className="font-bold text-[15px] mb-2">Favourites List</p>
            <div className="w-full">
              <CommonInput
                placeholder="Seacrh Member Here..."
                value={searchKeyword}
                onChange={(e) => setSearchKeyWord(e.target.value)}
                className="outline-none text-xs border m-4 w-1/2  border-gray-200 focus:border-primary   px-2 "
              />
            </div>
            <Spin spinning={loading}>
              <Table
                className="history-table animate-fade-in max-h-[500px]  overflow-x-auto text-white rounded-lg"
                columns={ReportColumn}
                pagination={false}
                dataSource={dataSource}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      setResult({
                        Favourite: 1,
                        Id: record.id,
                        MemberId: record.member_id,
                        MemberName: record.member_name,
                      });
                    },
                    className: "cursor-pointer text-[12px]",
                  };
                }}
              />
              <div className="mt-2 mb-8 flex justify-end items-center">
                <CommonPagination
                  totalPages={totalPages}
                  current={current}
                  pageSize={pageSize}
                  setCurrent={setCurrent}
                  setPageSize={setPageSize}
                />
              </div>
            </Spin>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendMoneyModal;
